import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AuthState} from '../../../interfaces/reducers/auth';
import {LoginDataType} from '../../../interfaces/api/auth/login';
import {initialFontReducer} from '../../../assets/static/fontChanger';

const initialState: AuthState = {
  currentUser: {},
  config: {
    font: initialFontReducer,
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<LoginDataType | null>) => {
      state.currentUser = action.payload;
    },
    logout: state => {
      state.currentUser = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {login, logout} = authSlice.actions;

export default authSlice.reducer;
